import cover from "../../assets/pic1.png";
export const source = () => {
  const result = [
    {
      title: "Qixxeessitinori",
      details: {
        html: `
        <h4>Qixxeessitinori</h4>
        <ol>
        <li>Dr. Mengistu Gebreyohanes,Miqichunna mikitate ispeeshaliste;
        Qoleno badhete duguguru miqichi ispeeshaliste</li>
        
        <li>Dr. Ephrem Gebrehana,Miqichunna mikitate ispeeshaliste;
        Qoleno lowo jaddonna mikkita soorate ispeeshaliste</li>
      </ol>
      <div style="padding-left: 30%;">
      <p>Hawaasa, Itophiya<br> 2016 M.D</p>
      </div>
      <table>
  <tr>
    <th>Loosishaanchote latishsha</th>
    <th>Ispoonserootu</th>
    </tr>
    <tr>
    <td>Ermias Kurabachew<br>+251 92 250 0469</td>
    <td>AO Alliance</td>
    </tr>
    </table>
     

    `,
      },
      image: "bosad_poster",
    },
    {
      title: "Borreessaanote Qoosso agarantinote",
      details: {
        html: `
        <h3>
        Qixxeessitinori:
        <ol>
          <li>Dr.Mangistu Gebreyohannis</li>
          <li>Dr.Ephrem Gebrehana</li>
        </ol>
        <ul>
          <li>
            Hawaasa, Itophiya <br>2016 M.D<br />
          </li>
        </ul>
      </h3>
    </div>
    <div class="chapter">
      <h3>Borreessaanote Qoosso agarantinote, 2016 M.D
      </h3>
      <h4>© All rights reserved 2023G.C</h4>
      <p style="padding-right: 10px;">
        
        Itophiyu giddo attamamino. Kiiro 410/2004, Qolleno Kirro 872/2014 Woyyeessinoonni lallawi garinni tenne
        maxxaaficho ayee gedeno ikkeenna bocose
        ikko wo’ma, fajjo nookkiha attamsiisanna tuqisa didandiinanni. Hattono umo
        borreessituri Itophiyu BOSAD xiinxallo gaamo fajjo nookkiha daata beezete
        woy komputerete giddo wodha/kuusi’rara didandiinanni.
      </p>
      <p style="padding-right: 10px;">
        Tini maxaaficho qixxaabbinohu BOSAD Xiinxallote gaamo riqiwatenni ikkanna
        Tajubba qinaabbinohu konne gobboomu Xiinxallo gaamonniiti.
      </p>
      <p style="padding-right: 10px;">
        Iimayidi Misilenna Dizayine – Dess Adivertayizinge Sidaamu Afiira qole
        tirinohu – Alemu Kirba
      </p>
      <p>
        Hedo’ne aa hasi’dhiniro - D/r Mangistu Gebreyohaannis
        Silke 0910120423 woy Imeele –
          mengistugmengesha@gmail.com
      </p>`,
      },
    },
    {
      title: "Galata",
      details: {
        html: `
        <p style="padding-right: 20px;">
        Tenne rosu mini qaaqquulli maxaaficho borreessano ikkankenni, Itophiyu
        BOSAD xiinxaawotenna xiinxallote gaamo gobboomu taje afi’nammora ganyote
        beeqqaano ikkitunkerira hunduruurru galatinke iillonsa. Qoleno, Amaaru
        Afiira, Afaan Oromote, Sidaamu Afiiranna Somaalete Afiira qolte
        dandootenni tirtu ogeeyyeta hellobuufonsa dinqeefanteemmo. Jeefote, Dr.
        Hizqiyas Kaasayeha, Ariyaayya Xilahuunniha, Tolosa Dinsiha, Abdullaahi
        Mohammad, Duk. Edeni Alamuta (BOSAD Xinxaawo Qineesaano) Addi addi Afiinni
        maxaaficho buuxatenna mucci assate assitino beeqqora lowonta
        galanteemmonsa.
      </p>
      <ol>
        <li>
          D/r Mangistu Gebreyohannis–
          <span class="s5">Miqichunna mikitate ispeeshaliste; Qoleno badhete duguguru miqichi
            ispeeshaliste</span>
        </li>
        <li>
          D/r Efireem Gebrehanna -
          <span class="s5">Miqichunna mikitate ispeeshaliste; Qoleno lowo jaddonna mikkita
            soorate ispeeshaliste</span>
        </li>
      </ol>`,
      },
    },
    {
      title: "Bitima",
      details: {
        html: `
        <div class="chapter-content">
        <p style="padding-right: 10px;">
          Rosu aana noo ooso, rosu mine hedeweelcho tunccu yitannonsa uwate
          jaddo gargarate hayyonna hosipitaale massine akkamote kaa’lo assate
          albaanni aana illachishanno rosi nookkihura batinye ooso miidhantanni
          leeltanno. Tini maxaaficho qixxabbinohu konne qarra tirate
          Itophiyunna Gaambiyu
          <b>“Bone Setting associated Disability /BOSAD/” </b>yinanni gobboomu
          baalate xiinxallo assate aana leeltanno ogeeyye gaamonniiti.
          Xiinxallote mixo miqichunna mikitate mii’ramme /musculoskeletal injury/
          hoccunni seekkine xaanxe, sissa ganne
          hasiisannokki cuukko qolle qolle cukkinananna daanno xurqanaamo
          fayyimmate qarra gargarateeti. Tini BOSAD yinanniti xiinxallote
          gaamo xaphoomu mixose gobbate giddo miqichohonna mikittate
          /musculoskeletal/ mii’rammera uyinanniha wo’manka hikkiminna
          woyyeessateeti.
        </p>
        <p style="padding-right: 10px;">
        Xiinxallo, saiha mitto dironna lee agana asinanni keeshshini yannara nafa rosu
        mine uwatenni bisinsara miiramme iillitinonsari batinye oosooti. Kuri ooso
        qarqarinsara afamanno budu ogeessiwa massineenna mii’ramino biso cuukkite,
        sissa gante usurteenna 7 barrinni 14 barri geeshsha mininni gobbara fulannokki
        assineenna keeshshitinota hatte yannara buunxoonni. Hakkunni gedensaanni xisso woyyaawa hooggenansa maatensa ikkito la’e mirimera assinanninna akkammanni gede fayyimmate uurrinshawa haadhe massitino. Fayyimmate uurrinshara
        assinoonni mirmarinni mii’raminohu oosote bisi kifele mittowido akkammeenna hurannokki widira gaangiriinete soorrame bisu muramannowa iillanno, woy
        hegere hegerera bisu xe’ne nooha ikke hee’rannoha ikkanno. Tini ikkito mittu
        miqichunna mikita hakimichi gede barru baali loosinke giddo xiinbanni honsanni
        loosooti.
        </p>
        <p style="padding-right: 10px;">
        Kuri ooso ubbe mii’ramme iillitanni heedheennansa yannatenni fayyimmate uurrinshawa massine hasiisanno hikkiminna assinnoommensaro, garunni akkamante hura dandiitanno. Ise calla ikkikkinni dancha fayyimmanni rosinsa aanira harancho yanna giddo higa dandiitanno. Tenne taje uyitannota harancho maxaaficho
        qixeessate hexxinoommohu qaru korkaati qarraho huwanyo kalaqatenna uwate
        korinni dagganno bisu mii’ramme gargarooshshu hayyo leellishateeti.
        </p>
        <p style="padding-right: 10px;">
        Mito mito woyite uwatenni kainohunni dagganno mii’ramme wo’munni wo’ma
        gargadha dandaa hongirono nafa uwihu kawaanni miidhami beetti/o aana wole
        mii’ramme lexxitannokki gede gargara dandiinanni. Hatto assinihu gedensaanni
        ranke huranno gara biddi assatenni keeraanchimmasi buuxantino hikkiminna aa
        hasiissanno. Tenne maxaaficho lexxiteno miidhantino ooso hosipitaale iillansara
        albaanni assa hasiissannonsare babbaxino hosipitaale iillansara albaanni assinanni
        hikkiminnu kaa’looshshubba kultannota ikkitanni kuriuu hikkiminnu kaa’looshshubba rosiisaano, rosaanote maatenna rosaano uminssa nabbawa, huwatanna ayee
        yannarano uwate jaddo tuncu yitunsaro garunni horoonsi’ra dandiitanno.
        </p>
        <p style="padding-right: 10px;">
        Baalinke anfoommonte gede ooso gana wedellimmate iillitinokki qacalu bisireeti.
        Bisuuno ikko buqqeetenni heesagisate ikkadimmansa jaawatinokkita ikkitinohura
        wolootu aana irki’raano ikkansa deerri luphi yiinoho. Assootinsanninna yaachishanno akatinsano jajjabbu wiinni baxxinoho. Isenkuraati konne umosi dandiinoha uwate jaddo korkaati oosote tuncu yaannonsa bisu mii’ramme aanaa illachishshannota harancho maxaaficho qixxeessa hasiissinohu.
        </p>
      </div>
      `,
      },
    },
    {
      title: `Maxaafichote Mixo`,
      details: {
        html: `
        <div class="chapter-content">
        <p style="padding-right: 10px;">
        Tenne maxaafichoti qara mixo rosu
        mini giddo uwatenni ka’nohunni
        oosote aana iillitanno mii’ramme
        oosote aana haadhe daggannota yaachishshanno ikkito hiitto gargara dandiinanniro xawisateeti. Addinnino,
        hosipitaale iillansara albaanni ha’runsa hasiissannonkere akkamote kaa’lo
        woy amadooshshu hayyo lainohunni
        rosu aana noo oosora, maatete, rosiisaanote, rosu mini miidiya loossanno
        ogeeyyera hattono xaphoomunni baalanku dagoomira mashalaqqe aateeti.
        Maxaaficho, Itophiyu giddo afantanno addi addi Afuubbara tirreenna rosu
        minnaranna dandiiniro ila ayiddira
        beenkanniha ikkanno.
        </p>
      </div>  `,
      },
    },
    {
      title: `Wodho`,
      details: {
        html: `
        <div class="chapter-content">
        <p style="padding-right: 10px;">
          Ooso-
          <span class="p">Tenne maxaaficho giddo ooso yaanno qaale horoonsi’noonnihu 18
            dirira woroonni noore xawisateeti. Xaphoomunni 12 kifile geeshsha
            noori rosonsa ha’runsate aana leeltanno ooso baala hanqafanno.</span>
        </p>
        <p style="padding-right: 10px;">
          Uwa woy uwatenni dagganno mii’ramme-
          <span class="p">Hedeweelcho wo’ma mannimmanni woy bisotenni baattote, uullu
            ragirana woy kayinni iiminni woriidi dirimira eelallicho mara ikke
            hallanyichu/tete aana mii’ramme abbara dandaanno ikkitooti.</span>
        </p>
        <p style="padding-right: 10px;">
          Mii’ramme woy bisu miidhama-
          <span class="p">Tenne maxaaficho giddo mii’rammenna bisu miidhama yitanno qaalla
            mimmito labbannota assine horoonsi’noommoha ikkanna tironsano
            hedeweelcho bisu aana iillitanno hekkonni dagganno bisu mii’rammeeti yaateeti.</span>
        </p>
      </div>  `,
      },
    },
    {
      title: `Rosu Aana Noo Ooso Uwate Jaddo Lainohunni Hasaawa Mayira Hasiisi?`,
      details: {
        html: `
        <div class="chapter-content">
        <ol>
          <li>
          Kalqete fayyimmate uurrinshi rippoorte garinni 18 dirinsa geeshsha
          afantanno oosora bisu mii’ramme, rewonna hegeraame midhamme abbannori sasu dhaaddote daanno kori giddo mittu oosote uwate jaddooti.
          </li>

          <li>
          Batinye lophitinokki gobbuwa giddo uwate jaddo lowo geesha rosante
          hedeweelcho akkamote kifile giddo la”antanno oosimmate yanna
          mii’ramme danaati. Baalunku bisi mii’ramme kori giddo uwate jaddo
          25- 50% beeqqo amaddanno.
          </li>

          <li>
          Roso mure fulate qara korkaata ikkitinori mereero mittu uwate ledo
          amadantino akkamootinna hegeraame bisu mii’rammeeti.
          </li>

          <li>
          Uwate korkaatinni daggannoti bisu mii’ramme seeda yannara goxenna harunsine xaginsanni akkamo hasidhannota ikkitinohura maateteno
          ikko xaphoomu dagoomi aana lowota dagoomittenna miinju fulo fushshiishshanni leelanno.
          </li>

          <li>
          Uwate jaddo Ameeriku giddo oosimmate yannara bisu mii’ramme
          korkaatinni daggannoti rewoo abbatenni shoolki deerrira uurrite leeltanno. Tini ikkito gobbankera konninni sase anga ero roortinota ikkitinohura qarru hakkiinni roorinoha ikkanno.
          </li>
          <li>
          Itophiyu giddo noonke rosichinni ooso uwate mii’ramme iillitunsa
          gedensaanni xurqanaamu qarrira sa’anna la”a rosantinota ikkitino.
          Sai sasu dirira Hawaasi yuuniveriste giddo assinoonni oppiraasoonera
          mii’ramino biso fushshine hunate/murate loosi mereero 17% ikkitannoti oosote akkamamaano aana loonsoonniho. Kunino ikkara dandiinohu
          mereerima bisu mii’ramme iilliteennansa mine maanxe hoccunni woy
          wolurinni usureenna keeshshihu gedensaanni bisu shola (gaangiriini)
          deerra iille dana soorramihu gedensaanni dagginohuraati.
          </li>
        </ol>
      </div>
          `,
      },
      image: 1,
    },
    {
      title: `Ooso Rosu Hoowe Giddo Mayira Ubbanno?`,
      details: {
        html: `
        <div class="chapter-content">
        <p>
Uwa mittu beetti lopho ha’rinsho giddo rosantinote. Qaafa rosa, mitturichi aanna fula, kubbanna qarqaraho kawa ka’a dowee la”a mittu qaaqqi assanni lophannorichooti. Hixu gede ikkeenna batinye uwa shollado midhamme abbitanno. Batinye ooso heeshshonsa dirrinni batinye higge ubbannoha ikkirono shota
bisu madi’ra agurranna hakkeeshshiti bunshete tuggannoti bisu mii’ramme
iillitannansa dianfanni. Rosu mini giddo ooso uwate korkaatinni dagganno
mii’rammera reqecci yaate dandiissiisannohu mitu mitu baxxino bayichubba
nooha ikkanna kuriuu giddo aane noori qaruubbaho.
        </p>
        <ol>
          <li>
          Shiimmaadda ooso miteekkite ooso awuutate qixxeessinoonni uduunne
          lawishshaho daaimoottu hossannowa noo uduunnichonna qaaqquullu
          qaafara worranni uduunnichinni ubbara dandiitanno.
          </li>

          <li>Wolootu kayinni ooso godo’litanno bayicho anfanni uduunnichi aaninni uwa dandiitanno.
          </li>

          <li>Minu aaninni uwa</li>

          <li>
          Shalaqishanno woy shamino bayicho kaxxite (baxinohunni xeenu yannara) uwa.
          </li>

          <li>Giddasincho fultannonna dirritanno wote hattono Xullaallicho(maskoote) kubbitay uwa dandiitanno.
          </li>

          <li>Rosu mini giddo haaro ijaara ijaarranniwa fulte uwa dandiitanno.</li>

          <li>Rosu mini giddo du’namaano hadhanno gadawiranna wayi bale giddo
          uwa dandiitanno.</li>

          <li>Ispoortenna (mannimmate guunte) boohaarshu millimmo yaano lekkatenna angate wkl. kuwaase godo’litanni uwa dandiitanno.
          </li>

          <li>Haqqichote aaninni uwa – gumma xinqidhanni- woy hattono godo’litanni haqqicho fultay dirritay uwa dandiitanno.</li>

          <li>
          Farado/harre guluffanni uwa- Baadiyyete ooso farado/harre guluffanni
          ubbe miidhantuhu gedensaanni dagganna la’nanni.
          </li>

          <li>
          Darawo darawonsawa godo’litanni sarraaqante woy qiqqisante ubbe
          miidhante daggannore la’noonni. Addinni ginde miidhante daggannori
          batinyeho.
          </li>
        </ol>
      </div>
          `,
      },
      image: 2,
    },
    {
      title: `Uwatenni Dagganno Bisu Mii’ramme Haadhe dagganori Maati?`,
      details: {
        html: `
        <div class="chapter-content">
        <p>
        Uwa abbitannorichi hi’noontichu/alutawi/
        coyi addi addi ikkito aana xintamannoha ikkanno. Lawishshu gede qaaqqu diri,
        uwino gottichu bayichi woy mii’rammete
        wolqa, mii’ramme iillitino ariite, uwi qaaqqi dirre baatto kisi garinna mii’rammete
        akati (bisu madi’reenna mundee gobbara
        higge du’nama woy gobbayidi mii’ramme
        mundaa hooga) haadhe daggannoreeti. Kuri
        mii’ramme hegere hegerera bisu xe’ne abbite maateenna dagoomu aana lowo duha no ikkitanno. Hakkiino sa’e rewoo abbitara dandiitanno.</p>
        <p>
        Uwate jaddonni dagganno mii’ramme bikki aantinore kamalanno.
        <ol type="1">
          <li>Dammisara dandiitanno jaddite/asseqaaqi/ surrete miidhama iillitanno</li>
          <li>Heeshshote heeshsho geeshsha bisu miidhama abbitannohura duguguru
          miqichi miidhama daggara dandiitanno</li>
          <li>Bisu muramanna heeshshote heeshsho miidhama</li>
          <li>Anganna lekkate hiiqqama</li>
          <li>Mada sholtanno gede assa reqecci assa- /fano hiiqqamme ikkituro/</li>
          <li>Lophote gufo mii’rama/ Growth plate injury/ Iseno yannatenni akkamama hoongiro miqichu shokkanna horonta higgannokkita bisu
          mii’ramme abbitara dandiitanno.</li>
          <li>Godowirunna hallu hattono gagasu aani mii’ramme abbitanno</li>
          <li>Mitte horonta qolle dandiinayikki bisu mii’ramme, hurtannokki, macciishshanna la”ate aana qarra abbitanno.</li>
          <li>Goofimarchoho luphiima wolqanni daggannoti bisu mii’ramme woy
          iimira fanfo bayichinni uwate ledo amadantino rewo tuncu yitara dandiitanno.</li>
        </ol>
        </p>
      </div>
          `,
      },
      image: 3,
    },
    {
      title: `Uwate Jaddonninna Umbihu Gedensaanni Dagganno Xurqanaawa Fayyimmate Qarruwa Hiitto Gargadha Dandiinanni?`,
      details: {
        html: `
        <div class="chapter-content">
        <p>Batinye fayyimma la’anno haja tuncu yitukkinni balanxe gargadha lowonta
        fulo ajishshanno hayyooti. Konni woroonni la’nannihu rosu mine uwate ledo
        amadantinori jaddaamma oosote bisu mii’rama gargaratenna baalunkura fulo
        ajishshanno akkamo aate assa hasiissanno assootubbaati.</p>
        <ol>
          <li>
          Dandiini bikinni rosu minna hoowe oosote injiitinota assa hasiissanno.
          Oosote injiitino rosu minna hoowe yineemmo wote yannicha ijjaara hasi’rannoha ikkikkinni hoowe shotu garinni ooso bayichi bayicho milli
          yaa dandiitannotanna midhamme abbitannokkita ikka noose yaankeeti.
          Hatto assiniro daaimu hoshsho uduunnichinna qaaqqu millisanno uduunnichi aana uwatenni kalaqantanno bisu mii’ramme ajisha dandiinanni.
          </li>
          <li>
          Rosu mini giddo godo’linanni bayichubba (giddasinchu, kubbinanninna shididiixxinanni uduunnicho) qixxeessinanninna qansanni wote,
          horote aana hosansara albaanni keeraanchimmansa bikka keenanna
          buuxa hasiissanno. Hatto assinniro ayee qaaqqino hasiissannokki uwate jaddoranna bisu mii’rammera reqecci diyaanno. Rosu mine godo’lete bayicho yanna yannantenni gatamarshu amanyoote qixxeessanna ooso
          ha’runsitannoreno wora hasiissanno. Godo’linannirichi hojja qaaqqu
          diri deerrira ikkitannota ikka noosi. Godo’litannorichi kubbite woy shididiixxite gawa’litannowi ullate garino taalinnoha ikka hasiissannosi.
          Miidhote reqecci assannokkiha shaqqado ikkinota buuxa hasiissanno.
          </li>

          <li>
          Rosu minnara fano ikkinohu iima qaaxi/xaaru/ hee’rannonsakki gede
          hasiisanno. Miteekkite ooso hakka fulte hedeweelcho ubbara dandiitanno. Hedeweelcho oosote uwa daggannokki gede gargarate qaaxubba,
          barandunna taqu itisanchi hee’ranno gede amaallanni. Lendeno ooso
          rosu mininsa hoowe giddo keeraanchimmansa agarate assa hasiissannorenna assa hasiissannonsakkire affanno gede mini-midiyu widoonni
          hattono rosaano soodonna hawarro gamba yitanno wote rosiisa bayira
          coyeeti.
          </li>
          <li>
          Rosu mini hoowe giddo leellannohu haameelo amadanno bayichi lawishshaho fanu wayi ha’ranno gadawinna bale tu’ne hoowe dandiini
          geeshsha keeraanchonna moola assa hasiissanno. Kuri fano haameelo
          amaddanno darguwi addanko jaddaammaho. Korkaatuno uwate kora
          ikkite ayeerano heeshshote qarra abbitara dandiitannoreeti. Hakko daafira Rosu mini hoowe giddo noo wayi ballanna gadawubba tuate dandiini geeshsha shalaqishanno bayichi hee’rannokki assa hasiissanno.
          </li>
          <li>
          Ooso fultannohunna dirritanno taqi mii’rammete reqecci assannokkiha
          ikkinota buuxa hasiissanno. Taqubba miidhote illishansara albaanni hasiisanno gatamarsha yanna yannatenni assa hasiisanno.
          </li>
          <li>
          Rosu mini hoowe giddo haaruu ijaarshi hee’ranno wote rosaano hakkira
          martannokki gede faajjete hoolloonni bayicho ikkinota borrote hajajonni kulle hoolate. Hakkunni aana lende hoolloonni jaddaamu bayichira
          maranno rosaanchi nooronna hoongoro yanna yannantenni ha’runsitanno gaama wora hasiissanno.
          </li>
          <li>
          Ispoortete woy boohaarshu loosi yannara luphi yitinota bisu mii’ramme
          ajishate rosaano darawo warawonsa ledo godo’litanno assate. Boohaarishshu dargi baato taaltinota ikka hasiissannose. Dandiinannihanna assinanniha ikkiro rosaano godo’litanno wote keeraanchimma agartanno
          qodho , lawishaho guluchu paade, cigilete paade, angate gufo keranchima agartanno qodho umu qooncho agartanno gullee horoonsi’ra hasiissanno.
          </li>
          <li>
          Mite mite ooso laalote gumma xinqidhara haqqicho fultannowote hedeweelcho ubbara dandiitanno. Wolootu kayinni darawonssa ledo godo’litara haqqete aanira fulte ubbeenna angansanna lekkansa mii’ranteenna fano hiiqqamme iilliteennansa dagganno. Ooso haqqete aanira
          fultannohu mayi korkaatinnino ikko rosu mini qorqoraanchi woy wolu
          loosaasinchinni ha’runsine haqqicho fultannokki gede hoola hasiissanno.
          </li>
          <li>
          Ooso baxinohunni shiimmaadda ooso farado woy harre gulufate fajja
          dihasiissanno. Konni kainohunni ubburo iillitannonsa mii’ramme qarrissannotanna rewote iillishshannota ikkitara hattono hegerera bisu
          xe’ne abbitara dandiitanno gede roso/qoropho aa hasiissanno.
          </li>
          <li>
          Ooso afateeno ikko afibbeelo xullaallote (Meskootete) widoonni kubbate wo’naalte bisu mii’rammera ubbannokki gede rosu mini xullaallubbara ittishsha wora danchate. Xaa yannara baalante rosi minnara
          xullaallubbaho ittishsha wora yannate faashineeti. Hakko daafira uwate
          korinni daggannoti bisu mii’ramme ajjishate widoonni xawe leellanno
          qeecha assinanni hee’noonni.
          </li>
        </ol>
      </div>
          `,
      },
      image: "4Sidama",
    },
    {
      title: `Rosu Mine Uweenna Mii’ramme Iillitinosi Beettira Hosipitaale Massate Albaanni Assinanni Akkamo/ Amadooshshe`,
      details: {
        html: `
        <div class="chapter-content">
        <p>
        Mittu beetti uweenna midhamme iillitusihu gedensaanni qooxeessaho noo manni qaaqqu lubbo gatisate balaxooshshe aa hasiissanno. Hakkiino sae wole bisu
        mii’ramme hoolate woy hegeraame bisu mii’ramme daggannokki gede gargara
        hasiissannosi. Qoleno xisso ajishatenna tiu/lii’lu kaa’lo assate qaafo adha hasiissanno. Konne assoote “Umi deerri kaa’lo” yine woshshinanni. Beettu lubbo
        gatisatenna mii’rammetenni kainohunni daannoricho lowonta ajjishate horaameete qaafooti.
        </p>
        <p>
        Baalanti rosu minna umi deerri kaa’lo uyinanni mereerishinna qajeeltino
        ogeeyye qixxeessi’ra balaxo uyinanno hajaati. Konnira luphiimu uduunnicho
        wonsha dihasiissanno.
        </p>
        <p>
          Hakkunninni aanchine ubbe bisu mii’ramme iillitinonsa rosaanora
          hasiisannota umi deerri kaa’lo aate dandiinanni gede aantawoore assa
          hasiissanno.</p>
        <ol>
          <li>Uwino/ubbino beetto qooxeessira noo manchi woloota qarqaraho afanno
          manna kaa’litasira woshshi’ranna dandaanno geeshshi akkamo aate iille”
          e yitanno raara raara noosi. Raare raaranni hee’re gawajamino beetto afi’ririnni kaa’late hellobuufo assa noosi. Konne balla umi deerri kaa’lo
          aate qajeelino manni nooro hakkawotenni woshshineenna daqiiqu giddo
          lubbo gatisate qaafo adha yaano miidhami beetto hasiisanno garinni ofoshshiisha hasiissanno. Diilallote fooleessi/tubbo garunni loossanni noota buuxa hasiissanno. Foolanni noo garanna ayeeno heeshshote waajjishshanno ikkito buuxanna taashsha hasiissanno.
          </li>
          <li>
          Heeshshote waajjishshanno ikkito nookkita buunxihu gedensaanni anchine baalanta mannimmate bissa fattaashate looso loosa hasiissanno.
          Hatte yannara beettu/o taalo uulla aana (afi’nummoha ikkiro dugugguru
          miqicho suwisanno haqqi aana/spine board/ goxisnse hiitti bisu kifile miidhantinoro woy jawa jaddaame xisso macciishshantanosiro/sero xa’ma
          noonke. Beettu/o ku’linokkiha/ku’litinokkiha maaxantino mii’ramme
          badate umu qoonchinni lekkate culunqichi geeshsha maraammara hasiissanno.
          </li>
          <li>Miqichunna mikitate mii’rammera (musculoskeletal injury) angatenna
          lekkate hiiqqamme nootanna hoogginota raajiweello maraammarre calla afate maramarannohu halaalaancho ikkinoha hiiqqammete malaatta
          yinannire horoonsi’ra dandaanno. Insano - 
          <ol type="a">
            <li>Miidhaantino bisu kifile aana macciishshantanno luphiima xisso</li>

            <li>Mii’rantinokki anga woy lekka ledo heesaginsanni wote faajjetenni leeltanno bisu shokkonna hara’ma</li>

            <li>Gobbaanni leeltannoti miqichu gane fullo (fano) hiiqqamme</li>

            <li>Mii’ramino bayichi milli yaanno wote kinsanniha woy macciishshinanni
            huuro (qaqa’a) yaara dandaanno. Kayinnilla huuro macciishshate yine
            assinanniti hasiissannokki millimmo mundeete boombenna narve miidho
            abbitara dandiitannohura assate wo’naala dihasiissanno</li>

            <li>Hattono miidhantino mannimma bisi aana noo doogimale ikkitino
            shashshafo woy millimmooti. Beettu/o aleenni kulliri mereero mittu nafa
            noosiha/sero ikkiro baalanka umi deerri kaa’lo assanna hakkawotenni hasiisannoha miqichu woy mikitate owaanye afi’rano bayicho sowaa hasiissanno.</li>
          </ol>
          </li>

          <li>
          Mii’rammete bayicho bande anfihu gedensaanni hiiqqamme woy gogu
          sholoolamme mii’ramme noota huluullammiro rosu mine haja la’annosi manchi ledo beettu/o maate umosi woy silkete woshshine hasaawisa hasiissanno. Konne mereero noo yannara beettuyihu/ote mii’ramino
          bisi kifile milli yitannokki assine amada hasiissanno. Angatenna lekkate
          mii’ramme (limb injury) yannate geeshsha irkise keeshshiishate rosu
          mini hoowe giddo afi’neemmore ayerichono yaano beettu/ote yuuniforme, kaartoonenna ayee hoccono horoonsi’ra dandiinanni.</li>
        </ol>
        </p>
      </div>
          `,
      },
      image: 5,
    },
    {
      title: `Uwate Jaddo Iillitino Qaaqqira/ora Umi Deerri Kaa’lo Aatto/a Wote Maassa Hasiissannohe?`,
      details: {
        html: `
        <div class="chapter-content">
        <p>
        Uwate jaddo iillitinosi/e beettira/ora mii’raminoha bisu kifile milli assinikki irkinse keeshshiishate hasiisanno assooti aantetenni konni woroonni shiqino.</p>
        <ol type="a">
          <li>Ayee mundaate ikkito nooha ikkiro umi deerri kaa’lo uyinanni kite(saaxine) giddo noo fooxinni mundee uurrisate wo’naalate. Kitete giddo ayee
          hocci hoogiro mundee uurrisate beettu/ote uddano woy rosu mini uddanonsa horoonsi’ra dandiinanni. Konne madate shollenni/ infection/ mundee
          uurrisate kaa’lo balaxo uyinannita ikkitino daafira afi’ni hocco horoonsi’ne
          mundaannowa uurrisa hasiissanno. Fooxa horoonsi’nanni wote erre uddisiisanna shabbi assine usurate ikkinnina mii’ramino bisira xaaxa dihasiissanno. Binqe xaanxiha ikkiro mundaanni no biso qalxe amadanno daafira
          mii’ramino bisi kifile woroonni noo mundee doyicho uurrisannohura roore
          mii’rammera sayise tuganno daafira qoropho assa hasiissanno. Mundee
          uurrisate hellobuufo assinanni yannara mundeete ba’nannikki gede meessaneeteho qoropho assa hasiissanno.
          </li>
          <li>
          Dandiinni geeshsha mii’ramino beetti/o bisi aana noo hoccuwa woy uddanna baala fushshate.
          </li>
          <li>
          Dugugguru miqichi aana mii’ramme hee’rate huluullo galturo qaaqqu hosipitaale eenna mii’ramme noosikkita buunxikkinni noo bayichinni milli
          assinikkinni noowa hee’reenna kaa’lo assa hasiissanno. Milli assiniro woy
          galchiniro hasiissannokki mii’ramme lexxiteenna narvete mii’ramme daggara dandiitanno daafira qoropho assa hasiissanno.
          </li>
          <li>Xabbe leeltanno shokkimma /deformity/ hee’ra hoogguro mii’rantino bisu
          kifile ofola soorrate woy taashate wo’naala dihasiissanno. Korkaatuno
          hasiissannokkita mii’ramme lede abbaranna qaaqqoho luphi yitino xisso
          abbannoha ikkara dandaanno. Hakko daafira noowa irkinse amada woyyitanno. Miteekke narvete loosinna mudeete doyicho jaddotenni kainohunni
          mii’rantinoha ikkiro yaano mii’ramate ka’aanni mitte millimmo nookkiro
          kikkisama macciishshantannosikkiha ikkiro, mundeete doyicho uurritinokkiha ikkiro, mii’rantinota bisu kifile lowonta milli assinikki ofolla bikkunni taashshiniro narvete loosinna mundeete bobbaha taaltanno assa dandiinanni.
          </li>
          <li>
          Mii’ramino biso noowa hee’reenna irkinse keeshshiishate wo’naallanni
          wote, mulekki nooha wole mancho bisu milli yaannokki gede kaa’lanohe
          gede assi.
          </li>
          <li>
          Mii’ramino biso irkisate ayeeno suwinoha hurashshoricho horoonsi’ra dandiinanni. Togoo xaawuli, kaartoonenna huraddu dullootta ikkitara dandiitanno. Konne balla qaru qari hasiisannorichi irkishaho horoonsi’nannirichi
          mii’ramino bisira ikkanno gede bikkasi taashsha hasiissanno.
          </li>
          <li>
          Irkisaancho worranni wote mii’ramino bisi aleenna woroonni lame mikitta
          woy mii’ramino bisi mule noo miqichi milli yaannokki assate wo’naalate.
          </li>

          <li>
          Mii’ramino biso usurranni wote xaanxanniha duu’ra dihasiissanno. Hatto
          assa mundeete bobbaha aana hekko abbitanno.
          </li>
          <li>Irkisannore worranni wote guluchu mikita 10-15 digire erantanno gede
          assate. Soodo miqichinna cigile kayinni 90 digire ikka noose. Hattono
          luuqqatenna angate gufo suwa hasiissanno.
          </li>
          <li>
          Irkisannore lashshi assine xaaxatenni woy mii’ramino bisi ledo usuratenni huluullo heedhannokki assi. Irkisaancho huluullo nookkiha assate bayichisinni kayisitto hocco woy uddano horoonsi’ri.
          </li>
          <li>
          Hakkunni gedensaanni beetto qarqaraho afantanno fayyimmate uurrinsha
          sowaate ikkito qineessa hasiissanno.
          </li>
          <li>
          Beettu/o fayyimmate uurrinsha sonkanni wote uwi yannara afi mancho
          woy umi deerri kaa’lo akkamo assihu ajjawe haa’re ha’riro uurrinshate noo
          fayyimmate owaante aannohura assinoonnire umi akkamo kaa’lo xawise
          uyiha ikkiro danchaho.
          </li>
        </ol>
      </div>
          `,
      },
      image: 6,
    },
    {
      title: `Uwinohura/ubbinotera Umi Dirimi Kaa’looshshi Akkamo Aatto/a Wote Assa Hasiissannokkirichi Maati?`,
      details: {
        html: `
        <div class="chapter-content">
        <ol>
        <li>
          Uwatenni kainohunni oosote aana iillitannota bisu mii’ramme shollinshe la’noonke. Baalanti iiminni ubbino ooso, Ispoortete millimmonni iillitanno mii’ramme, jawa wolqanni iillitinno bisu mii’ramme
          iillituro mii’ramino darginni macciishshantanno xisso korkaatinni hifatama leeltuha ikkiro mii’ramme shota assine la”a dihasiissanno. Hattono beettu/o uweenna/ubbeenna mii’ramme iillitusi/use gedensaanni
          wi’lannoha/ wi’litannoha ikkiro /turo mii’ramme shota gede hende
          mininsara sowaa dihasiissanno. Oosote miqichi kalaqamunni jajjabbunni baxxannoha ikkinohura -
          
          <ol type="a">
            <li>Oosonniti lophote gufo mii’ramme (growth plate injury),</li>
            <li>Miqichu mitto wido hiiqqama (greenstick fracture)</li>
            <li>Miqichu shiimare bocamate mii’ramme (torus fracture)</li>
            <li>miqichu shokko (plastic deformity) yinannirira reqecci yaate kaayyonsa
            lowote. Hakko daafira jaddote ikkito miqichohonna mikitate dare gowate
            isipeeshaaliste dottori marammare muro afi’ra geeshsha kunnii beetti/o
            hiiqqamme tuncu yitusi/e gede assine adha noonke.</li>
          </ol>
          </li>
          <li>Mii’ramme iillitinota bisu kifile cuukka, milli assa, woy beetto budu
          ogeessunniwa massa horonta dihasiissanno. Uwate jaddo iillitinonsa
          ooso baalante hasiisanno qajeelsha adhinohu miqichonna mikita dare
          gowanno hakimichi marammara hasiissanno. Ooso shotunni gaangiriinete, mundeete nigi mii’ramera, bisu shokkoranna labbanno xurqanaawu qarrira reqecci yitinoreeti. Konni aana lexxe oosote hiiqqamme hasiissanno garinni raaje ka”a hoogguronna qajeeltino akkamote
          ogeeyyenni marammarama hoogguro hiiqqammete dana afatenna badate qarrisannoha ikkanno. Mii’ramino beetti/o bisu kifile cuukkate
          woy milli assate wo’naala mittu manchi heeshsho yannara tuncu yitannosi xisso baalante baassino xisso abbitanno loosooti. Ooso cuukkinanni wote macciishshantannonsa xisso korkaatinni umonsa habbara dandiitanno daafira togoo assootinni umo agadha hasiissanno.
          </li>
          <li> Gadachite amaddano xaaxxo horoonsidhooti. Mii’rantino bisu kifile
          (anganna lekka) hoccunni honxe usurranni wote mundeete bobbaha
          uurritanno gede assitanno daafira sholate (gaangiriinete) widira hige
          soorramanno. Hakko daafira mii’ramino biso irkisate horoonsi’nee mo
          irkishshi baalunku dandiini garinni doyicho doyee usuramannoha ikka
          dinosi. Biso irkise amadanno gede calla shabbi assa hasiissanno.
          </li>
          <li>Mundee uurrisate xaaxotee gurdine usurrannire horoonsidhooti. Mundee
          uurrisate yine mii’ramino bisi aana xaaxo horoonsi’ra mundeete bobbaho (doyicho) aana hekko abbanno. Hakko daafira du’nantanno mundee
          uurrisate hedatto woyite hocco darrabbe amadanna mii’rantino anga/
          lekka ale qole gotti assannoricho calla horoonsi’ri. Hakkuyi aanchite
          mii’ramino/ntino qaaqqo fayyimmate uurrinshawa rakke soyi.
          </li>
        </ol>
      </div>
          `,
      },
      image: 7,
    },
    {
      title: `Uwino/Ubbino Qaaqqo Ayi, Mamootenna Hiitto Fayyimmate Uurrinshara Sonkanni?`,
      details: {
        html: `
        <div class="chapter-content">

        <p>Uwe/ubbe bisu mii’ramme iillitinosi/e beetti/o hattono aantinnori giddo mittu
        tuncu yiinosiha/ seta hakkawotenni fayyimmate uurrinsha sowaa hasiissanno.</p>
        <ol type="1">
          <li>Mii’rammete aane ayeeno mundiitanno mada heedhuro</li>
          <li>Aleenni kayinsiri halaalaancho ikkinoha hiiqqammete malaatta yinanniri
          heedhuro</li>
          <li>Ayeeno bisu kifilera mii’ramme tuncu yitino gede huluullo heedhuhero</li>
          <li>Mii’rantino mannimmate kifile aana xissonna darshe heedhuro</li>
          <li>Mii’rantino anga/lekka milli assate qarrisannoha ikkiro</li>
          <li>Shiimmaadda ooso ikkituro mii’rramme iillitunssa gedensaanni hixamanyite wi’litannoha ikkiro</li>
        </ol>
        <p>
        Ubbeenna mii’ramme iillitinonsa ooso rifere assate (sowaate) yanna lainohunni
        mii’ ramme tuncu yitino bayicho umi deerri akkamo kaa’lo uyine ikkito la’nanni. Kayinnilla mii’ramme shota ikka hoogguro beettu/o rosisira/era higgara
        dandaa hoogguro hakkawotenni qarqaraho leeltanno fayyimmate uurrinshara
        sonkanni. Qarra yannatenni marammarre anfe hasiissanno akkamo dandiini ariitenni uyiniro ikkadu gumi leellanno. Hakko daafira eeggatena uweenna/ubbeenna mii’ramme iillitinosi/e beetto atewa keeshshannokki gede assi.
        </p>
        <p>
        Ubbeenna mi’ramme iillitinonsa ooso hiitto sonkanniro lainohunni umo qaaqqu
        lubbonna mii’ramino bisi kifile gatisate dandaami geeshshinni umi deerri akkamo kaa’lo rosu mini deerrinni aa hasiissanno. Aanchine beettu/o maate ikkito
        afanno gede assine beettu/ote maate woy lossannohunni ledo fayyimmate uurrinsha massa hasiissanno. Beetto fayyimmate uurrinshara masse aate mittu rosu
        mini riqiwaanchi ledo ha’ra hasiissanno.
        </p>
      </div>
          `,
      },
      image: "8Sidama",
    },
    {
      title: `Qaru (Ille Ikkinohu ) Bisi Mii’ramme Amadooshshi Loossa Maati?`,
      details: {
        html: `
        <div class="chapter-content">
        <p>
        Uwe mi’rimino beetti/o tuncu yiinkero, hasiissanno akkamo hakko jaddo iiltinosi bayicho ayee bisi mii’ramme tuncu yinosi beetti gede umi deerri akkamo
        kaa’lo aa hanafa hasiissanno. Hakkunni gedensaanni beetto hasiissanno fayyimmate uurrinshawa masanna hasiisannore baala afi’ranno assa hasiissannosi.
        Kuri mereero qara qara ikkitino assootubba aantannoreeti.
        </p>
        <ol type="1">
          <li>
          Beettoho lubbosira yaachishanno mii’ramme nootanna hoogginota maramarre hakko garinni amadooshshe assinannisi. Ayee bisu mii’ramme
          akkamamanchira assinanni akkamote hayyo, “qinaabbinoti hekkiima
          jaddo lubbo gatisate” biddiishsha ha’runsitanno.
          </li>
          <li>
          Aantete mii’rammete dana kaima assidhe addi addi akkamo yaano xisso ga’labisate xagicho, infekshine hoolanno xagicho (baakiteera shaannoha, tetaanuse (afoo gonnochishannohura) xagicho hattono huxisanno dhibba (tuganno dhibbira) uyinanni xagicho marammarre anfirinni
          garinni akkamo uyinanni.
          </li>
          <li>Mada nooro mundaa uurrinsihu gedensaanni madate infekshine kalaqantannokki gede hayishine burquuqqanno jarmenni fayyo ikkino hoccinni ashshanganni.
          </li>
          <li>
          Xawoho leeltanno mii’rammete bisi shokkimmanna mikitate fula tuncu
          yituro qaaqqu xissote naxa ikkanno gede ikkado xissote ga’labishshi
          xagicho uyinihu gedensaanni taashshinanniha woy bayichosi qollanniha ikkanno. Kuni qarri tuncu yinosi qaaqqo mitto xagichono uyinikkinni taashshate wo’naala horontanni hoolloonnite. Mayira yiniro wolu
          rooru qarrira reqecci assannoha ikkinohura mii’ramme iillitu bayicho
          ikko fayyimmate uurrinshara xagicho uyinikkinni wo’naala dihasiissanno.
          </li>
          <li>
          Miiramino bisi kifilera hasiissanno akkamote biddiissubba ha’runsine
          yannate geeshsha bisu irkishsha worrannisi.
          </li>
          <li>
          Aanchine akkamamaanchu beetti hasiissannosi raajera sonkanni. Konne
          afa hasiissannohehu oosote aana dagganno hiiqqamme jajjabbu aana
          dagganno hiiqqammenni lowonta baxxitinota ikkitanna mii’ramme
          maramarate kayinsanni raaje baddannotanna qarraho uyinanni xawishshi qoropho amadino mirimari hasiisanno. Hakko daafira ayino raaje la”a dandaanno manchi baalanku beettu hiiqqamme mirimari guma
          shotunni la”ara didandaanno. Tenne afatenna qorophotenni badate handaaru ogeessa ikka hasiissanno. Konni daafira handaaraho qajeelsha
          adhinikki raaje hajajatenni egentinokkiri nabbabbannoha labbe ooso23
          wirro wirrote cuukkatenninna hoxxe usuratenni hasiisannokki qarrira
          reqecci assitannori, bae olluu budu ogeeyye batidhinohura ila ayiddi
          oosonsara uyinanni akkamo lainohunni qajeelino akkamote ogeessinni
          ikkinota buuxate sooreeyyimmanna giddeetu noonsa.
          </li>
          <li>
          Xaphooma mirmaranna raajete guma kaima assi’ne beettoho hasiisannoha nya”a akkamo lainohunni maatete woy lossidhannori ledo akkamote doorshshi aana hasaawa assinanni. Hakkiinni jeefote akkamo
          la’annosi ogeessinni uyinannita ikkitanno.
          </li>
          <li>
          Xaphoomunni oosote aana dagganno batinye bisu mii’ramme, darre
          gombannikki hayyonni akkamantannote. Konne kayinni garunni loosu aana hosannonna gumisi dancha ikkanno gede qajeelino akkamote
          ogeessi hasiisanno. Muli ha’runso assano hattono qara richooti. Ubbeenna mii’ramme iillitinonsa ooso woyyaabbino akkamo assinannihu
          xaphoomu mixosi/ alaama/ qarra yannatenni badatenna akkamate, rakke hurtannonna ooso rosinsa minira higganno gede dandiissate. Kuri
          aleenni tittirshunni kayinsi loossa baalanti garunni loonse uwate jaddo
          tuncu yitinonsa oosora la’nanniti roso mure fulatenna gatate qarrubba
          xawe leellanno garinni ajisha dandiinanni.
          </li>
        </ol>
      </div>
          `,
      },
      image: 9,
    },
    {
      title: `Maqishsha`,
      details: {
        html: `
        <div class="chapter-content">
        <ol>
          <li>World Health Organization (WHO).Injuries and Inequities-Guidance forAddressing Inequities in
            unintention-al Injuries. Copenhagen, Denmark:World Health Organization RegionalOfﬁce for Europe; 2014</li>
          
          <li>CDC, Injuries among Children andTeens report, https://www.cdc.gov/injury/features/child-injury/index.html
          </li>
          <li>Chapman RL, Buckley L, SheehanM, Shochet IM. Pilot evaluation ofan adolescent risk and injury pre-vention
            programme incorporatingcurriculum and school connected-ness components. Health Educ Res.2013;28(4):612–625
          </li>
          <li>James S.L, Lucchesi L.R, BisignanoC, Castle C.D, Dingels Z.V, et al.The global burden of falls: Global,
            re-gional and national estimates of mor-bidity and mortality from the GlobalBurden of Disease Study 2017.
            InjuryPrev. 2020, 26 (Suppl. 1), i3–i11</li>
          <li>Amy E Peden, Richard C Franklin,Child Injury Prevention: Is it time toaddress the determinants of
            Health.Children, 2021, 8:46.</li>
          <li>International Federation of Red crossand Red crescent Societies, Interna-tional First aid and
            Rescessitationguidelines, 2016</li>
          <li>Meghalaya State Disaster Man-agement Authority, Basic First AidManual, India, 2014</li>
          <li>Blake G, Velikonja D, Pepper V,Jilderda I, Georgiou G. Evaluating an in-school injury
            preventionprogramme’s effect on children’shelmet wearing habits. Brain Inj.2008;22(6):501–507</li>
          <li>Pickett, W.; Molcho, M.; Simpson,K.; Janssen, I.; Kuntsche, E.; Ma-zur, J.; Harel, Y.; Boyce, W.F.
            Crossnational study of injury and socialdeterminants in adolescents. InjuryPrev. 2005, 11, 213–218</li>
          <li>Lama Bou-Karroum, Fadi El-Jardali,Mathilda Jabbour, Aya Harb, RachaFadlallah, et al, Preventing
            Unin-tentional Injuries in School-AgedChildren: A Systematic Review.Paediatrics, 2022, 149:6</li>
          <li>UNICEF. Levels & Trends in ChildMortality Report 2019. New York,NY: UNICEF; 2020</li>
          <li>Jamison DT, Breman JG, MeashamAR, et al. Disease Control Prioritiesin Developing Countries. Washing-ton,
            DC: The World Bank; 2006</li>
          <li>Barcelos RS, Del-Ponte B, SantosIS. Interventions to reduce accidentsin childhood: a systematic review.
            JPediatr (Rio J). 2018;94(4):351–367</li>
          <li>Mytton J, Towner E, Brussoni M,Gray S. Unintentional injuries inschool-aged children and
            adolescents:lessons from a systematic review ofcohort studies. Inj Prev.2009;15(2):111–124</li>
          <li>Mock CN, Smith KR, Kobusingye O,et al. Injury Prevention and Environ-mental Health: Key Messages. 3rded.
            Disease Control Priorities. Vol 7.Washington, DC: The World Bank;2017</li>
          <li>Nauta J, van Mechelen W, OttenRHJ, Verhagen EALM. A system-atic review on the effectivenessof school and
            community-basedinjury prevention programmes onrisk behaviour and injury risk in 8-12year old children. J Sci
            Med Sport.2014;17(2):165–172</li>
          <li>Kendrick D, Mulvaney CA, YeL, Stevens T, Mytton JA, Stew-art-Brown S. Parenting interventionsfor the
            prevention of unintentionalinjuries in childhood. Cochrane Data-base Syst Rev. 2013;(3)</li>
          <li>Towner E, Dowswell T, Jarvis S.Updating the evidence. A systematicreview of what works in
            preventingchildhood unintentional injuries: part1. Inj Prev. 2001;7(2):161–164</li>
          <li>Kendrick D, Young B, Mason-JonesAJ, et al. Home safety education andprovision of safety equipment
            forinjury prevention. Cochrane DatabaseSyst Rev. 2012;(9)</li>
          <li>Pearson M, Garside R, Moxham T,Anderson R. Preventing unintentionalinjuries to children in the home:
            asystematic review of the effective-ness of programmes supplying and/or installing home safety
            equipment.Health Promot Int. 2011;26(3):376–392</li>
          <li>Pearson M, Hunt H, Garside R, Mox-ham T, Peters J, Anderson R. Prevent-ing unintentional injuries to
            children under 15 years in the outdoors: asystematic review of the effectivenessof educational programs. Inj
            Prev.2012; 18(2):113–123</li>
          <li>Orton E, Whitehead J, Mhizha-Mu-rira J, et al. School-based educationprogrammes for the prevention
            ofunintentional injuries in children andyoung people. Cochrane DatabaseSyst Rev. 2016;(12):CD010246</li>
          <li>Morrongiello BA, Lasenby-LessardJ. Psychological determinants of risktaking by children: an
            integrativemodel and implications for interven-tions. Inj Prev. 2007;13(1):20–25</li>
          <li>DelCastillo-Andres O, Toronjo-Hor-nillo L, Toronjo-Urquiza L. Effectsof fall training program on
            autom-atization of safe motor responsesduring backwards falls in school-agechildren. Int J Environ Res
            PublicHealth. 2019;16(21)</li>
          <li>WHO, Falls, Key facts, 2021, https://www.who.int/news-room/fact-sheets/detail/falls</li>
        </ol>
      </div>
          `,
      },
    },
  ];
  return result;
};
